"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryDomainTemplate = void 0;
const lit_html_1 = require("lit-html");
const _button_1 = require("./_button");
/**
 * Возвращает шаблон основного домена в списке
 */
function getPrimaryDomainTemplate(domain, advantagesTemplate, translations) {
    const ga = {
        item_name: domain.name,
        // item_id: "53245",
        price: domain.price,
        currency: 'USD',
        quantity: 1,
        item_brand: domain.name,
        item_category: domain.advantages.length > 0 ? domain.advantages.join(' ') : 'Without description of domain',
        item_variant: domain.premium ? 'Premium' : 'Standart',
        item_list_name: 'Category domains of 2 letters'
    };
    return (0, lit_html_1.html) `
        <div class="first-result__wrapper domain__wrapper_outer">
            <div class="domain__wrapper_left">
                <div class="domain domain-premium" data-id="${[domain.name, domain.zone].join('.')}" data-price="${domain.taken ? 0 : domain.price}">
                    <div class="domain__wrapper js-domain-ga" data-domain="${JSON.stringify(ga)}">
                        <div>
                            ${!domain.hideAvailability ? (0, lit_html_1.html) `
                                <div class="domain__availability">
                                    <span>
                                        ${translations.instant('domainIsAvailable')}
                                    </span>
                                </div>
                                <div class="domain-back-guarant hidden-xs">
                                    ${translations.instant('fiveDayMoneyBack')}
                                </div>
                            ` : null}
                        </div>
                        <div>
                            <div>
                                <div class="domain__primary">
                                    <a class="domain__name" href="/${translations.getLanguagePrefix()}/domain/${domain.name}">
                                        <span>${domain.name}</span>.<span>${domain.zone}</span>
                                    </a>
                                </div>
                                <div class="flex">
                                    ${domain.premium ? (0, lit_html_1.html) `
                                        <div class="domain__prefix">
                                            <span class="domain__icon"></span>
                                            ${translations.instant('premium')}
                                        </div>                        
                                    ` : null}
                                </div>
                                <div class="domain-back-guarant visible-xs">
                                    ${translations.instant('fiveDayMoneyBack')}
                                </div>                           
                            </div>
                            ${!domain.banned ? (0, lit_html_1.html) `
                                <div class="domain__tertiary">
                                    <div class="domain__price-info">
                                        ${domain.request ? (0, lit_html_1.html) `
                                            <div class="domain__price__request">${translations.instant('priceOnRequest')}</div>
                                        ` : !domain.taken ? (0, lit_html_1.html) `
                                            <div class="domain__amount">
                                                $ ${Intl.NumberFormat('en').format(domain.price)}
                                            </div>
                                            <div class="domain__rent-time">
                                                $ ${[Intl.NumberFormat('en').format(domain.renew), translations.instant('year')].join(' / ')}
                                            </div>
                                        ` : null}
                                    </div>
                                    <div class="domain__actions">
                                        ${(0, _button_1.getButtonTemplate)(domain, _button_1.ButtonTemplateStyle.TRANSPARENT, translations)}
                                    </div>
                                </div>
                            ` : (0, lit_html_1.html) `
                                <div class="domain__tertiary">
                                    <div class="domain__price-info"></div>
                                    <div class="domain__actions">
                                        ${(0, _button_1.getButtonTemplate)(domain, _button_1.ButtonTemplateStyle.TRANSPARENT, translations)}
                                    </div>
                                </div>
                            `}
                        </div>                    
                    </div>
                </div>
            </div>
            <div class="domain__wrapper_right">
                <div class="domain__wrapper_right-label">${translations.instant('alsoAvailableOn')}</div>
                <a class="domain__wrapper_right-btn domain__wrapper_right-btn-godaddy" href="https://www.godaddy.com/domainsearch/find?domainToCheck=${domain.name}.art" target="_blank">
                    <img src="/img/icons/godaddy.svg"/> GoDaddy
                </a>
                <a class="domain__wrapper_right-btn domain__wrapper_right-btn-namechimp" href="https://www.namecheap.com/domains/registration/results/?domain=${domain.name}.art" target="_blank">
                    <img src="/img/icons/namechimp.svg"/> Namecheap
                </a>
            </div>
            <div class="domain__premium-info">
                ${domain.bought || domain.banned ? null : advantagesTemplate}
            </div>
        </div>
    `;
}
exports.getPrimaryDomainTemplate = getPrimaryDomainTemplate;
